var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fx0",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.77778 1.77778"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fx1",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.77778 1.77778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 360,
    x2: 1280,
    y2: 360,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#066BAA",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#066BAA",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3C9576",
    stopOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64B450"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.08 394.898 917.091 393.798 918.153 423.748 887.142 424.849Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.08 394.898 917.091 393.798 918.153 423.748 887.142 424.849Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.08 394.898 917.091 393.798 918.153 423.748 887.142 424.849Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M972.496 472.813 1003.51 471.712 1004.57 501.663 973.559 502.763Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M972.496 472.813 1003.51 471.712 1004.57 501.663 973.559 502.763Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M972.496 472.813 1003.51 471.712 1004.57 501.663 973.559 502.763Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.765 469.048 915.776 467.948 916.838 497.899 885.827 498.999Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.765 469.048 915.776 467.948 916.838 497.899 885.827 498.999Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.765 469.048 915.776 467.948 916.838 497.899 885.827 498.999Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.005 557.421 920.016 556.32 921.079 586.271 890.068 587.371Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.005 557.421 920.016 556.32 921.079 586.271 890.068 587.371Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.005 557.421 920.016 556.32 921.079 586.271 890.068 587.371Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809.268 535.804 840.279 534.704 841.342 564.655 810.331 565.755Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809.268 535.804 840.279 534.704 841.342 564.655 810.331 565.755Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809.268 535.804 840.279 534.704 841.342 564.655 810.331 565.755Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M805.81 438.321 836.821 437.22 837.883 467.171 806.872 468.271Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M805.81 438.321 836.821 437.22 837.883 467.171 806.872 468.271Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M805.81 438.321 836.821 437.22 837.883 467.171 806.872 468.271Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1116.79 244.722 1147.8 243.622 1148.87 273.572 1117.85 274.672Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1116.79 244.722 1147.8 243.622 1148.87 273.572 1117.85 274.672Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1116.79 244.722 1147.8 243.622 1148.87 273.572 1117.85 274.672Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.21 322.636 1234.22 321.536 1235.28 351.487 1204.27 352.587Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.21 322.636 1234.22 321.536 1235.28 351.487 1204.27 352.587Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.21 322.636 1234.22 321.536 1235.28 351.487 1204.27 352.587Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1115.48 318.872 1146.49 317.772 1147.55 347.722 1116.54 348.823Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1115.48 318.872 1146.49 317.772 1147.55 347.722 1116.54 348.823Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1115.48 318.872 1146.49 317.772 1147.55 347.722 1116.54 348.823Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.72 407.244 1150.73 406.144 1151.79 436.095 1120.78 437.195Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.72 407.244 1150.73 406.144 1151.79 436.095 1120.78 437.195Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.72 407.244 1150.73 406.144 1151.79 436.095 1120.78 437.195Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1039.98 385.628 1070.99 384.528 1072.05 414.478 1041.04 415.579Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1039.98 385.628 1070.99 384.528 1072.05 414.478 1041.04 415.579Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1039.98 385.628 1070.99 384.528 1072.05 414.478 1041.04 415.579Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1036.52 288.144 1067.53 287.044 1068.6 316.995 1037.58 318.095Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1036.52 288.144 1067.53 287.044 1068.6 316.995 1037.58 318.095Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1036.52 288.144 1067.53 287.044 1068.6 316.995 1037.58 318.095Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720,
    fill: "url(#fill2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 289C814.5 277.678 824.797 268.5 837.5 268.5 850.203 268.5 860.5 277.678 860.5 289 860.5 300.322 850.203 309.5 837.5 309.5 824.797 309.5 814.5 300.322 814.5 289Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.5 225C894.5 213.678 904.574 204.5 917 204.5 929.426 204.5 939.5 213.678 939.5 225 939.5 236.322 929.426 245.5 917 245.5 904.574 245.5 894.5 236.322 894.5 225Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.5 149C896.5 137.678 906.797 128.5 919.5 128.5 932.203 128.5 942.5 137.678 942.5 149 942.5 160.322 932.203 169.5 919.5 169.5 906.797 169.5 896.5 160.322 896.5 149Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.5 313C894.5 301.678 904.797 292.5 917.5 292.5 930.203 292.5 940.5 301.678 940.5 313 940.5 324.322 930.203 333.5 917.5 333.5 904.797 333.5 894.5 324.322 894.5 313Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.5 231C980.5 219.678 990.574 210.5 1003 210.5 1015.43 210.5 1025.5 219.678 1025.5 231 1025.5 242.322 1015.43 251.5 1003 251.5 990.574 251.5 980.5 242.322 980.5 231Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 191C814.5 179.678 824.797 170.5 837.5 170.5 850.203 170.5 860.5 179.678 860.5 191 860.5 202.322 850.203 211.5 837.5 211.5 824.797 211.5 814.5 202.322 814.5 191Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 42.6517 27.6139",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 853.5 177.114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.5 205.5 901.209 298.516",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 65.4492 104.682",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 902.949 163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.5 163.5 986.954 216.18",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.876 230.538 939.5 224.5",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.5 245.5 918.156 293.013",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.5 191.5 894.199 225.008",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 26.8188 19.4844 26.8188C20.1747 26.8188 20.7344 26.2591 20.7344 25.5688 20.7344 24.8784 20.1747 24.3188 19.4844 24.3188L16.9625 24.3188C18.3623 22.9533 18.3901 20.7117 17.0247 19.3119 16.3516 18.622 15.4263 18.2362 14.4625 18.2437 13.3125 18.275 12.8531 18.7219 12.5562 18.8125 12.3192 18.8673 12.0822 18.7209 12.025 18.4844 11.9872 18.2551 12.1187 18.0315 12.3375 17.9531 14.4133 16.7368 17.0821 17.4335 18.2984 19.5093 18.4648 19.7933 18.5985 20.0953 18.6969 20.4094L20.9469 21.6 20.9469 22.5C20.9469 23.1903 21.5065 23.75 22.1969 23.75 22.8872 23.75 23.4469 23.1903 23.4469 22.5L23.4469 20.8469C23.4536 20.3899 23.2103 19.9657 22.8125 19.7406L19.0031 17.7281C20.625 16.2969 22 15.4281 22.5 13.3281 22.6305 12.5429 22.6018 11.7395 22.4156 10.9656 22.4156 10.7464 22.5933 10.5688 22.8125 10.5688L26.025 10.5688C26.207 10.5666 26.3855 10.5182 26.5438 10.4281 27.6406 9.78438 27.65 8.40938 27.625 7.98125 27.6186 7.89831 27.5882 7.81906 27.5375 7.75312L26.525 6.48125 26.525 6.48125C26.525 4.22188 24.6875 2.77813 22.4281 2.77187 20.1952 2.72958 18.3508 4.50541 18.3085 6.73831 18.3057 6.88825 18.3112 7.03819 18.325 7.1875 18.3458 7.45072 18.1847 7.69428 17.9344 7.77812 9.55937 10.7031 8.27187 17.3656 8.2 20.7687 7.41562 20.6406 7.40937 20.3625 7.40937 19.9688L7.40937 9.34375C7.40937 7.96303 6.29009 6.84375 4.90938 6.84375 3.52866 6.84375 2.40937 7.96303 2.40937 9.34375L2.40937 10.7125C2.40937 11.2303 2.82911 11.65 3.34687 11.65 3.86466 11.65 4.28438 11.2303 4.28438 10.7125L4.28438 9.375C4.28438 9.02981 4.56419 8.75 4.90938 8.75 5.25456 8.75 5.53437 9.02981 5.53437 9.375L5.53437 20C5.53437 22.0813 7.09687 22.5875 8.4 22.7094 9 24.9625 11.0469 26.7469 15.4969 26.8438Z",
    fill: "#3B7D23",
    transform: "matrix(1.03333 0 0 1 903 136)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 26.8188 19.4844 26.8188C20.1747 26.8188 20.7344 26.2591 20.7344 25.5688 20.7344 24.8784 20.1747 24.3188 19.4844 24.3188L16.9625 24.3188C18.3623 22.9533 18.3901 20.7117 17.0247 19.3119 16.3516 18.622 15.4263 18.2362 14.4625 18.2437 13.3125 18.275 12.8531 18.7219 12.5562 18.8125 12.3192 18.8673 12.0822 18.7209 12.025 18.4844 11.9872 18.2551 12.1187 18.0315 12.3375 17.9531 14.4133 16.7368 17.0821 17.4335 18.2984 19.5093 18.4648 19.7933 18.5985 20.0953 18.6969 20.4094L20.9469 21.6 20.9469 22.5C20.9469 23.1903 21.5065 23.75 22.1969 23.75 22.8872 23.75 23.4469 23.1903 23.4469 22.5L23.4469 20.8469C23.4536 20.3899 23.2103 19.9657 22.8125 19.7406L19.0031 17.7281C20.625 16.2969 22 15.4281 22.5 13.3281 22.6305 12.5429 22.6018 11.7395 22.4156 10.9656 22.4156 10.7464 22.5933 10.5688 22.8125 10.5688L26.025 10.5688C26.207 10.5666 26.3855 10.5182 26.5438 10.4281 27.6406 9.78438 27.65 8.40938 27.625 7.98125 27.6186 7.89831 27.5882 7.81906 27.5375 7.75312L26.525 6.48125 26.525 6.48125C26.525 4.22188 24.6875 2.77813 22.4281 2.77187 20.1952 2.72958 18.3508 4.50541 18.3085 6.73831 18.3057 6.88825 18.3112 7.03819 18.325 7.1875 18.3458 7.45072 18.1847 7.69428 17.9344 7.77812 9.55937 10.7031 8.27187 17.3656 8.2 20.7687 7.41562 20.6406 7.40937 20.3625 7.40937 19.9688L7.40937 9.34375C7.40937 7.96303 6.29009 6.84375 4.90938 6.84375 3.52866 6.84375 2.40937 7.96303 2.40937 9.34375L2.40937 10.7125C2.40937 11.2303 2.82911 11.65 3.34687 11.65 3.86466 11.65 4.28438 11.2303 4.28438 10.7125L4.28438 9.375C4.28438 9.02981 4.56419 8.75 4.90938 8.75 5.25456 8.75 5.53437 9.02981 5.53437 9.375L5.53437 20C5.53437 22.0813 7.09687 22.5875 8.4 22.7094 9 24.9625 11.0469 26.7469 15.4969 26.8438Z",
    fill: "#C04F15",
    transform: "matrix(1.03333 0 0 1 987 217)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 26.8188 19.4844 26.8188C20.1747 26.8188 20.7344 26.2591 20.7344 25.5688 20.7344 24.8784 20.1747 24.3188 19.4844 24.3188L16.9625 24.3188C18.3623 22.9533 18.3901 20.7117 17.0247 19.3119 16.3516 18.622 15.4263 18.2362 14.4625 18.2437 13.3125 18.275 12.8531 18.7219 12.5562 18.8125 12.3192 18.8673 12.0822 18.7209 12.025 18.4844 11.9872 18.2551 12.1187 18.0315 12.3375 17.9531 14.4133 16.7368 17.0821 17.4335 18.2984 19.5093 18.4648 19.7933 18.5985 20.0953 18.6969 20.4094L20.9469 21.6 20.9469 22.5C20.9469 23.1903 21.5065 23.75 22.1969 23.75 22.8872 23.75 23.4469 23.1903 23.4469 22.5L23.4469 20.8469C23.4536 20.3899 23.2103 19.9657 22.8125 19.7406L19.0031 17.7281C20.625 16.2969 22 15.4281 22.5 13.3281 22.6305 12.5429 22.6018 11.7395 22.4156 10.9656 22.4156 10.7464 22.5933 10.5688 22.8125 10.5688L26.025 10.5688C26.207 10.5666 26.3855 10.5182 26.5438 10.4281 27.6406 9.78438 27.65 8.40938 27.625 7.98125 27.6186 7.89831 27.5882 7.81906 27.5375 7.75312L26.525 6.48125 26.525 6.48125C26.525 4.22188 24.6875 2.77813 22.4281 2.77187 20.1952 2.72958 18.3508 4.50541 18.3085 6.73831 18.3057 6.88825 18.3112 7.03819 18.325 7.1875 18.3458 7.45072 18.1847 7.69428 17.9344 7.77812 9.55937 10.7031 8.27187 17.3656 8.2 20.7687 7.41562 20.6406 7.40937 20.3625 7.40937 19.9688L7.40937 9.34375C7.40937 7.96303 6.29009 6.84375 4.90938 6.84375 3.52866 6.84375 2.40937 7.96303 2.40937 9.34375L2.40937 10.7125C2.40937 11.2303 2.82911 11.65 3.34687 11.65 3.86466 11.65 4.28438 11.2303 4.28438 10.7125L4.28438 9.375C4.28438 9.02981 4.56419 8.75 4.90938 8.75 5.25456 8.75 5.53437 9.02981 5.53437 9.375L5.53437 20C5.53437 22.0813 7.09687 22.5875 8.4 22.7094 9 24.9625 11.0469 26.7469 15.4969 26.8438Z",
    transform: "matrix(1.03333 0 0 1 900 210)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 26.8188 19.4844 26.8188C20.1747 26.8188 20.7344 26.2591 20.7344 25.5688 20.7344 24.8784 20.1747 24.3188 19.4844 24.3188L16.9625 24.3188C18.3623 22.9533 18.3901 20.7117 17.0247 19.3119 16.3516 18.622 15.4263 18.2362 14.4625 18.2437 13.3125 18.275 12.8531 18.7219 12.5562 18.8125 12.3192 18.8673 12.0822 18.7209 12.025 18.4844 11.9872 18.2551 12.1187 18.0315 12.3375 17.9531 14.4133 16.7368 17.0821 17.4335 18.2984 19.5093 18.4648 19.7933 18.5985 20.0953 18.6969 20.4094L20.9469 21.6 20.9469 22.5C20.9469 23.1903 21.5065 23.75 22.1969 23.75 22.8872 23.75 23.4469 23.1903 23.4469 22.5L23.4469 20.8469C23.4536 20.3899 23.2103 19.9657 22.8125 19.7406L19.0031 17.7281C20.625 16.2969 22 15.4281 22.5 13.3281 22.6305 12.5429 22.6018 11.7395 22.4156 10.9656 22.4156 10.7464 22.5933 10.5688 22.8125 10.5688L26.025 10.5688C26.207 10.5666 26.3855 10.5182 26.5438 10.4281 27.6406 9.78438 27.65 8.40938 27.625 7.98125 27.6186 7.89831 27.5882 7.81906 27.5375 7.75312L26.525 6.48125 26.525 6.48125C26.525 4.22188 24.6875 2.77813 22.4281 2.77187 20.1952 2.72958 18.3508 4.50541 18.3085 6.73831 18.3057 6.88825 18.3112 7.03819 18.325 7.1875 18.3458 7.45072 18.1847 7.69428 17.9344 7.77812 9.55937 10.7031 8.27187 17.3656 8.2 20.7687 7.41562 20.6406 7.40937 20.3625 7.40937 19.9688L7.40937 9.34375C7.40937 7.96303 6.29009 6.84375 4.90938 6.84375 3.52866 6.84375 2.40937 7.96303 2.40937 9.34375L2.40937 10.7125C2.40937 11.2303 2.82911 11.65 3.34687 11.65 3.86466 11.65 4.28438 11.2303 4.28438 10.7125L4.28438 9.375C4.28438 9.02981 4.56419 8.75 4.90938 8.75 5.25456 8.75 5.53437 9.02981 5.53437 9.375L5.53437 20C5.53437 22.0813 7.09687 22.5875 8.4 22.7094 9 24.9625 11.0469 26.7469 15.4969 26.8438Z",
    fill: "#002060",
    transform: "matrix(1.03333 0 0 1 901 298)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 26.8188 19.4844 26.8188C20.1747 26.8188 20.7344 26.2591 20.7344 25.5688 20.7344 24.8784 20.1747 24.3188 19.4844 24.3188L16.9625 24.3188C18.3623 22.9533 18.3901 20.7117 17.0247 19.3119 16.3516 18.622 15.4263 18.2362 14.4625 18.2437 13.3125 18.275 12.8531 18.7219 12.5562 18.8125 12.3192 18.8673 12.0822 18.7209 12.025 18.4844 11.9872 18.2551 12.1187 18.0315 12.3375 17.9531 14.4133 16.7368 17.0821 17.4335 18.2984 19.5093 18.4648 19.7933 18.5985 20.0953 18.6969 20.4094L20.9469 21.6 20.9469 22.5C20.9469 23.1903 21.5065 23.75 22.1969 23.75 22.8872 23.75 23.4469 23.1903 23.4469 22.5L23.4469 20.8469C23.4536 20.3899 23.2103 19.9657 22.8125 19.7406L19.0031 17.7281C20.625 16.2969 22 15.4281 22.5 13.3281 22.6305 12.5429 22.6018 11.7395 22.4156 10.9656 22.4156 10.7464 22.5933 10.5688 22.8125 10.5688L26.025 10.5688C26.207 10.5666 26.3855 10.5182 26.5438 10.4281 27.6406 9.78438 27.65 8.40938 27.625 7.98125 27.6186 7.89831 27.5882 7.81906 27.5375 7.75312L26.525 6.48125 26.525 6.48125C26.525 4.22188 24.6875 2.77813 22.4281 2.77187 20.1952 2.72958 18.3508 4.50541 18.3085 6.73831 18.3057 6.88825 18.3112 7.03819 18.325 7.1875 18.3458 7.45072 18.1847 7.69428 17.9344 7.77812 9.55937 10.7031 8.27187 17.3656 8.2 20.7687 7.41562 20.6406 7.40937 20.3625 7.40937 19.9688L7.40937 9.34375C7.40937 7.96303 6.29009 6.84375 4.90938 6.84375 3.52866 6.84375 2.40937 7.96303 2.40937 9.34375L2.40937 10.7125C2.40937 11.2303 2.82911 11.65 3.34687 11.65 3.86466 11.65 4.28438 11.2303 4.28438 10.7125L4.28438 9.375C4.28438 9.02981 4.56419 8.75 4.90938 8.75 5.25456 8.75 5.53437 9.02981 5.53437 9.375L5.53437 20C5.53437 22.0813 7.09687 22.5875 8.4 22.7094 9 24.9625 11.0469 26.7469 15.4969 26.8438Z",
    fill: "#C00000",
    transform: "matrix(1.03333 0 0 1 822 274)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8719 26.8188 19.4844 26.8188C20.1747 26.8188 20.7344 26.2591 20.7344 25.5688 20.7344 24.8784 20.1747 24.3188 19.4844 24.3188L16.9625 24.3188C18.3623 22.9533 18.3901 20.7117 17.0247 19.3119 16.3516 18.622 15.4263 18.2362 14.4625 18.2437 13.3125 18.275 12.8531 18.7219 12.5562 18.8125 12.3192 18.8673 12.0822 18.7209 12.025 18.4844 11.9872 18.2551 12.1187 18.0315 12.3375 17.9531 14.4133 16.7368 17.0821 17.4335 18.2984 19.5093 18.4648 19.7933 18.5985 20.0953 18.6969 20.4094L20.9469 21.6 20.9469 22.5C20.9469 23.1903 21.5065 23.75 22.1969 23.75 22.8872 23.75 23.4469 23.1903 23.4469 22.5L23.4469 20.8469C23.4536 20.3899 23.2103 19.9657 22.8125 19.7406L19.0031 17.7281C20.625 16.2969 22 15.4281 22.5 13.3281 22.6305 12.5429 22.6018 11.7395 22.4156 10.9656 22.4156 10.7464 22.5933 10.5688 22.8125 10.5688L26.025 10.5688C26.207 10.5666 26.3855 10.5182 26.5438 10.4281 27.6406 9.78438 27.65 8.40938 27.625 7.98125 27.6186 7.89831 27.5882 7.81906 27.5375 7.75312L26.525 6.48125 26.525 6.48125C26.525 4.22188 24.6875 2.77813 22.4281 2.77187 20.1952 2.72958 18.3508 4.50541 18.3085 6.73831 18.3057 6.88825 18.3112 7.03819 18.325 7.1875 18.3458 7.45072 18.1847 7.69428 17.9344 7.77812 9.55937 10.7031 8.27187 17.3656 8.2 20.7687 7.41562 20.6406 7.40937 20.3625 7.40937 19.9688L7.40937 9.34375C7.40937 7.96303 6.29009 6.84375 4.90938 6.84375 3.52866 6.84375 2.40937 7.96303 2.40937 9.34375L2.40937 10.7125C2.40937 11.2303 2.82911 11.65 3.34687 11.65 3.86466 11.65 4.28438 11.2303 4.28438 10.7125L4.28438 9.375C4.28438 9.02981 4.56419 8.75 4.90938 8.75 5.25456 8.75 5.53437 9.02981 5.53437 9.375L5.53437 20C5.53437 22.0813 7.09687 22.5875 8.4 22.7094 9 24.9625 11.0469 26.7469 15.4969 26.8438Z",
    fill: "#78206E",
    transform: "matrix(1.03333 0 0 1 822 176)"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#fx0)",
    transform: "translate(100 189)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.72829 8.99138 70.485 8.99138 70.485 67.4109 8.72829 67.4109Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.485 8.99138 132.242 8.99138 132.242 67.4109 70.485 67.4109Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.242 8.99138 193.999 8.99138 193.999 67.4109 132.242 67.4109Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.999 8.99138 255.755 8.99138 255.755 67.4109 193.999 67.4109Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.755 8.99138 317.512 8.99138 317.512 67.4109 255.755 67.4109Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.512 8.99138 379.269 8.99138 379.269 67.4109 317.512 67.4109Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72829 67.4109 70.485 67.4109 70.485 125.964 8.72829 125.964Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.485 67.4109 132.242 67.4109 132.242 125.964 70.485 125.964Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.242 67.4109 193.999 67.4109 193.999 125.964 132.242 125.964Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.999 67.4109 255.755 67.4109 255.755 125.964 193.999 125.964Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.755 67.4109 317.512 67.4109 317.512 125.964 255.755 125.964Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.512 67.4109 379.269 67.4109 379.269 125.964 317.512 125.964Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72829 125.964 70.485 125.964 70.485 184.384 8.72829 184.384Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.485 125.964 132.242 125.964 132.242 184.384 70.485 184.384Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.242 125.964 193.999 125.964 193.999 184.384 132.242 184.384Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.999 125.964 255.755 125.964 255.755 184.384 193.999 184.384Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.755 125.964 317.512 125.964 317.512 184.384 255.755 184.384Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.512 125.964 379.269 125.964 379.269 184.384 317.512 184.384Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72829 184.384 70.485 184.384 70.485 242.803 8.72829 242.803Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.485 184.384 132.242 184.384 132.242 242.803 70.485 242.803Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.242 184.384 193.999 184.384 193.999 242.803 132.242 242.803Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.999 184.384 255.755 184.384 255.755 242.803 193.999 242.803Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.755 184.384 317.512 184.384 317.512 242.803 255.755 242.803Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.512 184.384 379.269 184.384 379.269 242.803 317.512 242.803Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72829 242.803 70.485 242.803 70.485 301.223 8.72829 301.223Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.485 242.803 132.242 242.803 132.242 301.223 70.485 301.223Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.242 242.803 193.999 242.803 193.999 301.223 132.242 301.223Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.999 242.803 255.755 242.803 255.755 301.223 193.999 301.223Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.755 242.803 317.512 242.803 317.512 301.223 255.755 301.223Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.512 242.803 379.269 242.803 379.269 301.223 317.512 301.223Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72829 301.223 70.485 301.223 70.485 359.642 8.72829 359.642Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.485 301.223 132.242 301.223 132.242 359.642 70.485 359.642Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.242 301.223 193.999 301.223 193.999 359.642 132.242 359.642Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.999 301.223 255.755 301.223 255.755 359.642 193.999 359.642Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.755 301.223 317.512 301.223 317.512 359.642 255.755 359.642Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.512 301.223 379.269 301.223 379.269 359.642 317.512 359.642Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.485 6.99138 70.485 361.642",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.242 6.99138 132.242 361.642",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.999 6.99138 193.999 361.642",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.755 6.99138 255.755 361.642",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.512 6.99138 317.512 361.642",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72829 67.4109 381.269 67.4109",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72829 125.964 381.269 125.964",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72829 184.384 381.269 184.384",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72829 242.803 381.269 242.803",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72829 301.223 381.269 301.223",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72829 6.99138 8.72829 361.642",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.269 6.99138 379.269 361.642",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72829 8.99138 381.269 8.99138",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72829 359.642 381.269 359.642",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M116.271 205.534 178.027 205.534 178.027 263.953 116.271 263.953Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.027 205.534 239.784 205.534 239.784 263.953 178.027 263.953Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.784 205.534 301.541 205.534 301.541 263.953 239.784 263.953Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 205.534 363.298 205.534 363.298 263.953 301.541 263.953Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.298 205.534 425.054 205.534 425.054 263.953 363.298 263.953Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.054 205.534 486.811 205.534 486.811 263.953 425.054 263.953Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.271 263.953 178.027 263.953 178.027 322.507 116.271 322.507Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.027 263.953 239.784 263.953 239.784 322.507 178.027 322.507Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.784 263.953 301.541 263.953 301.541 322.507 239.784 322.507Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 263.953 363.298 263.953 363.298 322.507 301.541 322.507Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.298 263.953 425.054 263.953 425.054 322.507 363.298 322.507Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.054 263.953 486.811 263.953 486.811 322.507 425.054 322.507Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.271 322.507 178.027 322.507 178.027 380.926 116.271 380.926Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.027 322.507 239.784 322.507 239.784 380.926 178.027 380.926Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.784 322.507 301.541 322.507 301.541 380.926 239.784 380.926Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 322.507 363.298 322.507 363.298 380.926 301.541 380.926Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.298 322.507 425.054 322.507 425.054 380.926 363.298 380.926Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.054 322.507 486.811 322.507 486.811 380.926 425.054 380.926Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.271 380.926 178.027 380.926 178.027 439.346 116.271 439.346Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.027 380.926 239.784 380.926 239.784 439.346 178.027 439.346Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.784 380.926 301.541 380.926 301.541 439.346 239.784 439.346Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 380.926 363.298 380.926 363.298 439.346 301.541 439.346Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.298 380.926 425.054 380.926 425.054 439.346 363.298 439.346Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.054 380.926 486.811 380.926 486.811 439.346 425.054 439.346Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.271 439.346 178.027 439.346 178.027 497.765 116.271 497.765Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.027 439.346 239.784 439.346 239.784 497.765 178.027 497.765Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.784 439.346 301.541 439.346 301.541 497.765 239.784 497.765Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 439.346 363.298 439.346 363.298 497.765 301.541 497.765Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.298 439.346 425.054 439.346 425.054 497.765 363.298 497.765Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.054 439.346 486.811 439.346 486.811 497.765 425.054 497.765Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.271 497.765 178.027 497.765 178.027 556.185 116.271 556.185Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.027 497.765 239.784 497.765 239.784 556.185 178.027 556.185Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.784 497.765 301.541 497.765 301.541 556.185 239.784 556.185Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 497.765 363.298 497.765 363.298 556.185 301.541 556.185Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.298 497.765 425.054 497.765 425.054 556.185 363.298 556.185Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.054 497.765 486.811 497.765 486.811 556.185 425.054 556.185Z",
    fill: "#0B76A0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.027 203.534 178.027 558.185",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.784 203.534 239.784 558.185",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.541 203.534 301.541 558.185",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.298 203.534 363.298 558.185",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.054 203.534 425.054 558.185",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.271 263.953 488.811 263.953",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.271 322.507 488.811 322.507",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.271 380.926 488.811 380.926",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.271 439.346 488.811 439.346",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.271 497.765 488.811 497.765",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.271 203.534 116.271 558.185",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.811 203.534 486.811 558.185",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.271 205.534 488.811 205.534",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.271 556.185 488.811 556.185",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.598 550.529C802.197 539.227 812.073 529.703 824.656 529.257 837.238 528.811 847.764 537.611 848.165 548.913 848.566 560.215 838.69 569.739 826.108 570.185 813.525 570.631 802.999 561.831 802.598 550.529Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.572 483.721C879.171 472.419 889.046 462.895 901.629 462.449 914.212 462.002 924.737 470.802 925.138 482.104 925.539 493.406 915.664 502.93 903.081 503.377 890.498 503.823 879.973 495.023 879.572 483.721Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.166 408.087C878.765 396.785 888.64 387.261 901.223 386.814 913.806 386.368 924.331 395.168 924.732 406.47 925.133 417.772 915.258 427.296 902.675 427.742 890.092 428.189 879.567 419.389 879.166 408.087Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.364 572.109C882.963 560.807 892.838 551.283 905.421 550.837 918.004 550.391 928.529 559.191 928.93 570.493 929.331 581.795 919.456 591.318 906.873 591.765 894.29 592.211 883.765 583.411 883.364 572.109Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.702 486.707C965.301 475.405 975.177 465.881 987.76 465.435 1000.34 464.988 1010.87 473.788 1011.27 485.09 1011.67 496.392 1001.79 505.916 989.212 506.363 976.629 506.809 966.103 498.009 965.702 486.707Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.14 453.046C798.739 441.744 808.614 432.22 821.197 431.773 833.78 431.327 844.305 440.127 844.706 451.429 845.107 462.731 835.232 472.255 822.649 472.701 810.066 473.148 799.541 464.348 799.14 453.046Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 42.6518 27.6139",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0.999371 -0.035455 -0.035455 -0.999371 837.52 437.196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.547 466.136 889.523 557.402",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.702 486.707 925.138 482.104",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.081 503.377 905.421 550.837",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#3B7D23",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 886.08 394.898)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#C04F15",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 972.496 472.813)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 884.765 469.048)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#002060",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 889.005 557.421)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#C00000",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 809.268 535.804)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#78206E",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 805.81 438.321)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 67.4152 49.8219",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 988.915 506.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 16.7051 53.8235",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-0.939541 0.342435 0.342435 0.939541 821.992 471.678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.31 400.353C1032.91 389.051 1042.79 379.527 1055.37 379.081 1067.95 378.634 1078.48 387.435 1078.88 398.737 1079.28 410.038 1069.4 419.562 1056.82 420.009 1044.24 420.455 1033.71 411.655 1033.31 400.353Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.28 333.545C1109.88 322.243 1119.76 312.719 1132.34 312.272 1144.92 311.826 1155.45 320.626 1155.85 331.928 1156.25 343.23 1146.38 352.754 1133.79 353.2 1121.21 353.647 1110.69 344.847 1110.28 333.545Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.88 257.91C1109.48 246.608 1119.35 237.085 1131.94 236.638 1144.52 236.192 1155.04 244.992 1155.44 256.294 1155.85 267.596 1145.97 277.12 1133.39 277.566 1120.8 278.013 1110.28 269.212 1109.88 257.91Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.08 421.933C1113.68 410.631 1123.55 401.107 1136.13 400.661 1148.72 400.214 1159.24 409.014 1159.64 420.316 1160.04 431.618 1150.17 441.142 1137.59 441.589 1125 442.035 1114.48 433.235 1114.08 421.933Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.42 336.531C1196.01 325.229 1205.89 315.705 1218.47 315.258 1231.06 314.812 1241.58 323.612 1241.98 334.914 1242.38 346.216 1232.51 355.74 1219.92 356.186 1207.34 356.633 1196.82 347.833 1196.42 336.531Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.85 302.869C1029.45 291.567 1039.33 282.043 1051.91 281.597 1064.49 281.151 1075.02 289.951 1075.42 301.253 1075.82 312.555 1065.94 322.079 1053.36 322.525 1040.78 322.971 1030.25 314.171 1029.85 302.869Z",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "#E8E8E8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 42.6518 27.6139",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0.999371 -0.035455 -0.035455 -0.999371 1068.23 287.019)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.26 315.96 1120.24 407.226",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.42 336.531 1155.85 331.928",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#3B7D23",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 1116.79 244.722)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#C04F15",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 1203.21 322.636)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 1115.48 318.872)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#002060",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 1119.72 407.244)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#C00000",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 1039.98 385.628)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8557 26.7913 19.4645 26.7913C20.1541 26.7913 20.7132 26.2323 20.7132 25.5426 20.7132 24.853 20.1541 24.2939 19.4645 24.2939L16.9452 24.2939C18.3435 22.9299 18.3713 20.6905 17.0073 19.2922 16.3349 18.6029 15.4106 18.2176 14.4477 18.2251 13.2989 18.2563 12.84 18.7027 12.5434 18.7933 12.3066 18.848 12.0698 18.7018 12.0127 18.4655 11.975 18.2364 12.1063 18.0131 12.3249 17.9348 14.3986 16.7197 17.0646 17.4157 18.2797 19.4894 18.4459 19.7731 18.5795 20.0747 18.6778 20.3885L20.9255 21.5779 20.9255 22.477C20.9255 23.1666 21.4846 23.7257 22.1742 23.7257 22.8638 23.7257 23.4229 23.1666 23.4229 22.477L23.4229 20.8256C23.4296 20.369 23.1866 19.9453 22.7892 19.7205L18.9837 17.71C20.6039 16.2802 21.9775 15.4124 22.477 13.3145 22.6074 12.5301 22.5787 11.7275 22.3927 10.9544 22.3927 10.7355 22.5702 10.558 22.7892 10.558L25.9984 10.558C26.1803 10.5558 26.3586 10.5074 26.5166 10.4175 27.6124 9.77438 27.6217 8.40078 27.5968 7.97309 27.5904 7.89024 27.56 7.81107 27.5094 7.7452L26.4979 6.47463 26.4979 6.47463C26.4979 4.21756 24.6623 2.77529 22.4052 2.76904 20.1746 2.72679 18.3321 4.5008 18.2898 6.73143 18.287 6.88121 18.2925 7.031 18.3063 7.18016 18.3271 7.44311 18.1662 7.68642 17.916 7.77018 9.54961 10.6922 8.26342 17.3479 8.19162 20.7475 7.40805 20.6195 7.4018 20.3417 7.4018 19.9483L7.4018 9.3342C7.4018 7.95489 6.28367 6.83676 4.90436 6.83676 3.52505 6.83676 2.40691 7.95489 2.40691 9.3342L2.40691 10.7016C2.40691 11.2188 2.82622 11.6381 3.34346 11.6381 3.86071 11.6381 4.28 11.2188 4.28 10.7016L4.28 9.36542C4.28 9.02059 4.55952 8.74106 4.90436 8.74106 5.24919 8.74106 5.52872 9.02059 5.52872 9.36542L5.52872 19.9796C5.52872 22.0587 7.08962 22.5644 8.39142 22.6862 8.9908 24.937 11.0356 26.7195 15.481 26.8163Z",
    fill: "#78206E",
    transform: "matrix(1.03476 -0.0367106 0.035455 0.999371 1036.52 288.144)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 1.02677 34.705",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 1132.5 313.205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 131.894 33.6654",
    stroke: "#000000",
    strokeWidth: 2.66667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1204.39 351.5)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#fx1)",
    transform: "translate(548 308)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.82849 42.3285 151.829 42.3285 151.829 7.46449 219.692 75.3286 151.829 143.192 151.829 108.328 6.82849 108.328ZM8.62849 106.528 153.629 106.528 153.629 138.847 217.147 75.3286 153.629 11.8101 153.629 44.1285 8.62849 44.1285ZM10.4285 45.9285 155.429 45.9285 155.429 16.1557 214.601 75.3286 155.429 134.501 155.429 104.728 10.4285 104.728ZM15.8285 99.3284 160.829 99.3284 160.829 121.465 206.965 75.3286 160.829 29.1925 160.829 51.3285 15.8285 51.3285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M552 347.5 697 347.5 697 312.636 764.864 380.5 697 448.364 697 413.5 552 413.5ZM553.8 411.7 698.8 411.7 698.8 444.018 762.318 380.5 698.8 316.982 698.8 349.3 553.8 349.3ZM555.6 351.1 700.6 351.1 700.6 321.327 759.773 380.5 700.6 439.673 700.6 409.9 555.6 409.9ZM561 404.5 706 404.5 706 426.636 752.136 380.5 706 334.364 706 356.5 561 356.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/DNA.006768cd7a971aa3ddf5e86ecbb3cc98.svg";
export { ForwardRef as ReactComponent };